import { render, staticRenderFns } from "./ClaimAccordion.vue?vue&type=template&id=0b437ac6&"
import script from "./ClaimAccordion.vue?vue&type=script&lang=js&"
export * from "./ClaimAccordion.vue?vue&type=script&lang=js&"
import style0 from "./ClaimAccordion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports